module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) { fox.registerWidget('SitePage_About', {}, 'Site_Page'); })(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/about.js
// module id = 1258
// module chunks = 4